'use strict'

$id = $('body').attr('id')
$class = $('body').attr('class')

resizeFlg = {}
resizeFlg.pc = true
resizeFlg.sp = true
firstView = ''

spSubMenu = ()->
  if $('.p-sub-menu').length
    offset1 = $('.p-h1').outerHeight() + $('.p-breadcrumb').outerHeight()
    offset2 = $('.p-h1').outerHeight() + $('.p-header__inner').outerHeight()

    $('.p-sub-menu.js-headroom').headroom({
      offset: offset1
    })

    $(window).on('scroll',
      ()->
        if ($(this).scrollTop()) > offset2
          $('.p-sub-menu.js-headroom').addClass('is-hide')
        else
          $('.p-sub-menu.js-headroom').removeClass('is-hide')

        if ($(this).scrollTop() + $(window).height()) > $('.p-footer').offset().top
          $('.p-sub-menu.js-headroom').addClass('is-bottom')
        else
          $('.p-sub-menu.js-headroom').removeClass('is-bottom')
    )

if window.matchMedia('(max-width:750px)').matches
  # SP
  firstView = 'SP'

  spSubMenu()
else
  # PC
  firstView = 'PC'

  spSubMenu()

$(window).on('resize',
  ()->
    if window.matchMedia('(max-width:750px)').matches
      if firstView is 'PC' and resizeFlg.sp is true or
      firstView is false and resizeFlg.sp is true
        # PC から SP へ

        spSubMenu()

        resizeFlg.pc = true
        resizeFlg.sp = false
        firstView = false
    else
      if firstView is 'SP' and resizeFlg.pc is true or
      firstView is false and resizeFlg.pc is true
        # SP から PC へ

        spSubMenu()

        resizeFlg.pc = false
        resizeFlg.sp = true
        firstView = false
)
